import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import { Button as ReactButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import {
  Save,
  Delete,
  Assignment,
  Attachment,
  FilterNone,
  CloudUpload,
  ArrowBackIos
} from '@mui/icons-material';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane, faEdit } from '@fortawesome/free-solid-svg-icons'
import ImportExport from './ImportExport';
import { scrolledMoreThan } from '../utils/window';
import NewBuyerDialog from "./NewBuyerDialog";
import { WithTracking } from "./WithTracking";
import { TrackingCtx  } from "../tracking";
const Button = WithTracking(ReactButton);

library.add(faPaperPlane, faEdit);

const styles = theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  bar: {
    minHeight: 50,
    position:'fixed',
    width: '100%',
    background: theme.palette.common.white,
    borderBottom: '1px solid #c8c8c8'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  extraMargin: {
    marginRight: 20
  }
});

class IoToolbar extends Component {
  state = {
    sticky: false,
    showBuyerDialog: false,
    cloneDialogOpen: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.paint);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.paint);
  }

  handleChangeBuyer = () => {
    this.setState({ showBuyerDialog: true });
  };

  handleNewBuyerClose = buyer => {
    const { onChange } = this.props;
    if (buyer) {
      onChange({ target: { name: 'buyerId', value: buyer.buyeraccountid } });
      onChange({ target: { name: 'buyerName', value: buyer.name } });
    }
    this.props.onChangeBuyer(buyer);
    this.setState({ showBuyerDialog: false });
  };

  showBuyer = () => {
    this.setState({ showBuyerDialog: true });
  };

  paint = () => {
    const { sticky } = this.state;

    if (scrolledMoreThan(60) && !sticky) {
      this.setState({ sticky: true })
    }

    if (!scrolledMoreThan(60) && sticky) {
      this.setState({ sticky: false })
    }
  };

  render() {
    const { sticky, showBuyerDialog } = this.state;
    const {
      classes,
      isNew,
      isLocked,
      theme,
      onBack,
      onSave,
      onClone,
      canClone,
      onPushOrder,
      cannotPushReason,
      onExport,
      onImport,
      canImportExport,
      canDelete,
      onDelete,
      onSelect,
      onReopen,
      onRequestAcceptance,
      programmaticState,
      toggleChangeLog,
      toggleAttachments,
      togglePushSettings,
      importExportOpen,
      toggleImportExport,
      importErrors,
      constants,
      geos,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      onTemplateDownload,
      isReadOnly,
      dispatch
    } = this.props;

    const background = sticky ? theme.palette.primary.light : theme.palette.common.white;
    const newBuyerMsg = 'Select a new buyer by name or ID. A new proposal will be generated and sent to this buyer. The old one will be archived.'

    return (
      <div>
        <TrackingCtx.Consumer>
        {tracking => (<TrackingCtx.Provider value={{...tracking, action:"IO Toolbar"}}>
        {showBuyerDialog && !isReadOnly && (
          <NewBuyerDialog
            message={newBuyerMsg}
            buyerExists={false}
            open
            onClose={this.handleNewBuyerClose}
            onSelect={onSelect}
          />
        )}
        {!showBuyerDialog && (
          <div className={classes.root}>
            <Toolbar
              className={classes.bar}
              style={{ background }}
            >
              <Button onClick={onBack} className={classes.extraMargin} color="primary" tracking={{action: 'Back'}}>
                <ArrowBackIos className={classes.leftIcon} />
                Back
              </Button>

              {!isReadOnly && (
                <Button onClick={onSave} color="primary" disabled={isLocked} tracking={{action: 'Save'}}>
                <Save className={classes.leftIcon} />
                Save
              </Button>
              )}

            {!isReadOnly && !isNew && cannotPushReason && (
              <Tooltip title={cannotPushReason}>
                  <span>
                    <Button color="primary" disabled={isLocked || !onPushOrder || cannotPushReason} tracking={{action: 'Push'}}>
                      <CloudUpload className={classes.leftIcon} />
                      Ad Manager Push
                    </Button>
                  </span>
                </Tooltip>
              )}

              {!isReadOnly && !isNew && !cannotPushReason && (
                <Button onClick={togglePushSettings} color="primary" disabled={isLocked || !onPushOrder || cannotPushReason} tracking={{action: 'Ad Manager Push'}}>
                  <CloudUpload className={classes.leftIcon} />
                  Ad Manager Push
                </Button>
              )}

              {!isReadOnly && !isNew && canImportExport && (
                <ImportExport
                  onExport={onExport}
                  onImport={onImport}
                  open={importExportOpen}
                  toggleImportExport={toggleImportExport}
                  importErrors={importErrors}
                  constants={constants}
                  geos={geos}
                  strategies={strategies}
                  deviceTypes={deviceTypes}
                  salesProducts={salesProducts}
                  creativeProducts={creativeProducts}
                  presets={presets}
                  onTemplateDownload={onTemplateDownload}
                  isLocked={isLocked}
                  dispatch={dispatch}
                />
              )}

              {!isReadOnly && !isNew && canClone && onClone && (
                <Button color="primary" onClick={onClone} tracking={{action: 'Clone'}}>
                  <FilterNone className={classes.leftIcon} />
                  Clone
                </Button>
              )}
              {/*
              {!isReadOnly && !isNew && canClone && onClone && (
                <Button color="primary" onClick={setCloneDialog} tracking={{action: 'Clone'}}>
                  <FilterNone className={classes.leftIcon} />
                  Clone
                </Button>
              )}
              */}
              {!isNew && (
                <Button color="primary" onClick={toggleChangeLog} tracking={{action: 'Change Log'}}>
                  <Assignment className={classes.leftIcon} />
                  Change Log
                </Button>
              )}

              {!isNew && toggleAttachments && (
                <Button color="primary" onClick={toggleAttachments} tracking={{action: 'Attachments'}}>
                  <Attachment className={classes.leftIcon} />
                  Attachments
                </Button>
              )}

              {!isReadOnly && !isNew && onDelete && canDelete && (
                <Button color="secondary" onClick={onDelete} disabled={isLocked} tracking={{action: 'Delete'}}>
                  <Delete className={classes.leftIcon} />
                  Delete
                </Button>
              )}

              {!isReadOnly && programmaticState === 'DraftOrReopened' && (
                <Button onClick={onRequestAcceptance} color="primary" tracking={{action: 'Send To Buyer'}}>
                  <FontAwesomeIcon icon="paper-plane" className={classes.leftIcon} />
                  Send To Buyer
                </Button>
              )}

              {!isReadOnly && programmaticState === 'SentToBuyer' && (
                <Button onClick={this.handleChangeBuyer} color="primary" tracking={{action: 'Change Buyer'}}>
                  <FontAwesomeIcon icon="edit" className={classes.leftIcon} />
                  Change Buyer
                </Button>
              )}

              {!isReadOnly && programmaticState === 'Finalized' && (
                <Button onClick={onReopen} color="secondary" tracking={{action: 'Reopen Proposal'}}>
                  <FontAwesomeIcon icon="paper-plane" className={classes.leftIcon} />
                  Reopen Proposal
                </Button>
              )}

            </Toolbar>
          </div>
        )
        }
      </TrackingCtx.Provider>
      )}
      </TrackingCtx.Consumer>
      </div>
    )
  }
}

IoToolbar.defaultProps = {
  toggleChangeLog: null,
  toggleImportExport: null,
  onDelete: null
};

IoToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  isNew: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  toggleChangeLog: PropTypes.func,
  toggleImportExport: PropTypes.func,
  canDelete: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onRequestAcceptance: PropTypes.func.isRequired,
  onChangeBuyer: PropTypes.func.isRequired,
  programmaticState: PropTypes.string.isRequired
};

export default withStyles(styles, { withTheme: true })(IoToolbar);
